module.exports = __webpack_public_path__ + "img/6.18b72d6a.png";